










































































import { CourseLicenseTemplateFilterOptions } from '@/jbi-shared/dto/jtms.dtos';
import { Debounce } from '@/jbi-shared/util/debounce.vue-decorator';
import {
  GetGroupsProductResponsePayload,
  GroupProduct
} from '@/store/modules/admin/types/group-product.types';
import { RootState } from '@/store/store';
import { IPaginationOptions } from 'nestjs-typeorm-paginate';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Action, State } from 'vuex-class';

@Component({})
export default class CourseLicenseTemplateSearch extends Vue {
  @Prop(Object)
  courseLicenseTemplateFilterParams!: CourseLicenseTemplateFilterOptions;

  selectedGroupProductOption: GroupProduct = {
    id: 0,
    name: 'All Products',
    applicationId: 0
  };

  @Action('admin/getGroupProducts')
  getGroupProducts!: (
    options: IPaginationOptions
  ) => Promise<GetGroupsProductResponsePayload>;

  @State((state: RootState) => state.admin.groupProducts)
  groupProducts!: GetGroupsProductResponsePayload;

  get groupProductOptions() {
    if (this.groupProducts) {
      return this.groupProducts.items;
    }

    return [];
  }

  created() {
    this.getGroupProducts({
      page: 1,
      // Use larger limit to retrieve all group products to prevent creating new API
      limit: Math.pow(10, 3)
    });
  }

  resetFilter() {
    return this.$emit('resetFilter');
  }

  @Watch('selectedGroupProductOption')
  onSelectedGroupProductOptionChanged() {
    if (this.selectedGroupProductOption.name === 'All Products') {
      this.courseLicenseTemplateFilterParams.product = '';
      return;
    }

    this.courseLicenseTemplateFilterParams.product = this.selectedGroupProductOption.name;
  }

  @Watch('courseLicenseTemplateFilterParams', { deep: true })
  @Debounce(600)
  public onChange() {
    if (this.courseLicenseTemplateFilterParams.product === '') {
      this.selectedGroupProductOption = {
        id: 0,
        name: 'All Products',
        applicationId: 0
      };
    }
    this.$emit('input', this.courseLicenseTemplateFilterParams);
  }
}
